export default __webpack_public_path__ + "static/media/college.958678a8.PNG";